var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwingSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 343.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23 0h495.54c.8 0 1.54.33 2.06.86.53.53.86 1.26.86 2.06v29.23c0 .8-.33 1.53-.86 2.06s-1.26.86-2.06.86h-13.99l17.06 296.42h4.57c.33 0 .59.27.59.59v10.43c0 .32-.28.59-.59.59h-35.57c-.31 0-.59-.27-.59-.59v-10.43c0-.32.26-.59.59-.59h6.95L465.73 35.07h-45.8v209.84h-8.86V35.07H300.18v209.84h-8.85V35.07h-70.66v209.84h-8.86V35.07H100.93v209.84h-8.86V35.07h-45.8L29.21 331.49h6.95c.33 0 .59.28.59.59v10.43c0 .31-.28.59-.59.59H.59c-.31 0-.59-.27-.59-.59v-10.43c0-.33.26-.59.59-.59h4.57L22.22 35.07H8.23c-.8 0-1.53-.33-2.06-.86-.53-.52-.86-1.26-.86-2.06V2.92c0-.8.33-1.53.86-2.06S7.43 0 8.23 0zm272.3 252.35h150.19c1.58 0 2.87 1.3 2.87 2.87v18.49c0 1.57-1.3 2.87-2.87 2.87H280.53c-1.57 0-2.86-1.29-2.86-2.87v-18.49c0-1.58 1.28-2.87 2.86-2.87zm-199.25 0h150.18c1.58 0 2.87 1.3 2.87 2.87v18.49c0 1.57-1.29 2.87-2.87 2.87H81.28c-1.57 0-2.87-1.29-2.87-2.87v-18.49c0-1.58 1.29-2.87 2.87-2.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwingSet);
export default __webpack_public_path__ + "static/media/swing-set.8dc22ccd9fc787812d138936499669b7.svg";
export { ForwardRef as ReactComponent };